// extracted by mini-css-extract-plugin
export default {"cars":"styles_cars__y4Am7"};